export default __webpack_public_path__ + "static/media/1961.45d73430.png";